var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar-container",attrs:{"role":"progressbar","aria-valuemin":"0","aria-valuemax":"100","aria-valuenow":_vm.currentProgress}},_vm._l((_vm.progressSegments),function(segment,index){return _c('div',{key:index,class:['progress-bar', segment.status],style:({
      '--progress': `${segment.percent}%`,
    })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }